<template>
  <button
    class="h-fit p-1 rounded-full bg-bgr opacity-80 hover:bg-bgr-100 transition focus:bg-bgr-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover pointer-events-auto"
    @click.prevent.stop="handleClick"
  >
    <WebccIcon
      filled
      :name="isBookmarked ? 'site/bookmark-filled' : 'site/bookmark'"
      class="h-6 w-6"
    />
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{ accom: ResultDocument }>()

const tracking = useTracking()

const { isBookmarked, toggle } = useWishlistItemToggle(() => props.accom)

async function handleClick() {
  toggle()

  tracking.handlers?.ecommerce.toggleWishlist(props.accom, isBookmarked.value)
  tracking.handlers?.search.toggleWishlist(props.accom, isBookmarked.value)
}
</script>
